RivalIQ.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.User = Backbone.Model.extend({
        type: 'User',
        urlRoot: '/api/users',

        initialize: function () {
            const me = this;
            me.on('request', me.filterAttributes, me);
        },

        patchSettings: function (settings, options) {
            const me = this;
            options = _.extend({
                validate: true,
                method: 'patch'
            }, options);

            if (!me.set({
                settings: _.extend({}, me.get('settings'), settings)
            }, options)) {
                return false;
            }

            options.attrs = settings;
            options.url = `${me.url()}/settings`;
            options.success = function (resp) {
                RivalIQ.settings.userSettings = resp;
                me.trigger('sync', me, resp);
            };

            return (me.sync || Backbone.sync).call(me, 'update', me, options);
        },

        // Attributes that should not be saved to the model long term
        filterAttributes: function () {
            const me = this;

            _.each(['password', 'current_password', 'password_confirmation'], function (attr) {
                me.unset(attr, {
                    silent: true
                });
            });
        },

        validate: function (attrs, options) {
            const me = this;
            const errors = [];

            function field(name) {
                return _.includes(options.fields, name);
            }

            if (field('name') && !attrs.first_name) {
                errors.push(['first_name', 'First name is required.']);
            }

            if (field('name') && !attrs.last_name) {
                errors.push(['last_name', 'Last name is required.']);
            }

            if (field('email')) {
                if (!attrs.email) {
                    errors.push(['email', 'Email is required.']);
                } else if (!me.isNew() && !options.xhr) {
                    if (!attrs.email_confirmation) {
                        errors.push(['email_confirmation', 'Please confirm your email address change.']);
                    } else if (attrs.email !== attrs.email_confirmation) {
                        errors.push(['email_confirmation', 'Email confirmation must match.']);
                    }
                }
            }

            if (field('role') && !_.exists(attrs.role_id)) {
                errors.push(['role_id', 'A Role is required.']);
            }

            // Read-Only requires a read-only landscape
            const roleId = attrs.role_id || me.get('role_id');
            if (me.isNew() && (roleId === RivalIQ.enums.roles.readOnly.id) &&
                (!attrs.readOnlyLandscape)) {
                errors.push(['readOnlyLandscape', 'Please pick a landscape.']);
            }

            // If password is a field on this form and we are not validating a server
            // response, validate the fields
            if (field('password') && !options.xhr) {
                if (me.isNew() && !attrs.current_password) {
                    errors.push(['current_password', 'You must provide your current password.']);
                }

                if (!attrs.password) {
                    errors.push(['password', 'Password is required']);
                } else if (attrs.password_confirmation !== attrs.password) {
                    errors.push(['password_confirmation', 'Password Confirmation must match password.']);
                }
            }

            if (field('gdpr')) {
                if (!_.exists(attrs.terms_and_conditions)) {
                    errors.push(['terms_and_conditions', 'Please accept the Terms of Use.']);
                }
            }

            if (errors.length) {
                return errors;
            }
        },

        save: function (attrs, options) {
            const me = this;

            const roleId = attrs.role_id || me.get('role_id');
            if (me.isNew() && roleId !== RivalIQ.enums.roles.readOnly.id) {
                delete attrs.readOnlyLandscape;
            }

            if (me.isNew()) {
                return me.invite.apply(me, arguments);
            }

            if (me.get('id') === RivalIQ.state.user.get('id') && me.isInvited()) {
                return me.activate.apply(me, arguments);
            }

            options.success = function (child) {
                // On save update the team's landscapes for the ui
                if (me.isActive() && attrs.email) {
                    RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ChangedEmail);
                }

                // On change to owner set the old owner to full
                if (me.collection && attrs.role_id === RivalIQ.enums.roles.owner.id) {

                    const previousOwner = me.collection.find(function (user) {
                        return user.get('role_id') === RivalIQ.enums.roles.owner.id && user.id !== child.id;
                    });

                    previousOwner.set({
                        role_id: RivalIQ.enums.roles.full.id
                    });
                }
            };

            return Backbone.Model.prototype.save.apply(me, arguments);
        },

        invite: function (attrs, options) {
            const me = this;
            options = _.extend({
                validate: true,
                parse: true
            }, options);

            if (!me.set(attrs, options)) {
                return false;
            }

            options.url = `${me.url()}/invite`;
            options.success = function (resp) {
                const serverAttrs = (options.parse ? me.parse(resp, options) : resp);
                me.set(serverAttrs, options);
                me.trigger('sync', me, resp);
            };

            return (me.sync || Backbone.sync).call(me, 'create', me, options);
        },

        reinvite: function (attrs, options) {
            const me = this;
            options = _.extend({
                validate: true,
                parse: true
            }, options);

            if (!me.set(attrs, options)) {
                return false;
            }

            options.url = `${me.url()}/invite`;
            options.success = function (resp) {
                const serverAttrs = (options.parse ? me.parse(resp, options) : resp);
                me.set(serverAttrs, options);
                me.trigger('sync', me, resp);
            };

            return (me.sync || Backbone.sync).call(me, 'update', me, options);
        },

        resetPassword: function (attrs, options) {
            const me = this;
            options = _.extend({
                validate: true,
                parse: true
            }, options);

            if (!me.set(attrs, options)) {
                return false;
            }

            options.url = `${me.url()}/password`;
            options.success = function (resp) {
                me.trigger('sync', me, resp);
            };

            return (me.sync || Backbone.sync).call(me, 'update', me, options);
        },

        resetApiKey: function (attrs, options) {
            const me = this;
            options = _.extend({
                validate: true,
                parse: true
            }, options);

            options.url = `${me.url()}/apikey`;
            options.success = function (resp) {
                me.set('api_key', resp);
                me.trigger('sync', me, resp);
            };

            return (me.sync || Backbone.sync).call(me, 'update', me, options);
        },

        activate: function (attrs, options) {
            const me = this;
            options = _.extend({
                validate: true,
                parse: true
            }, options);

            if (!me.set(attrs, options)) {
                return false;
            }

            options.url = [me.url(), 'activate'].join('/');
            options.success = function (resp) {
                me.trigger('sync', me, resp);
            };

            return (me.sync || Backbone.sync).call(me, 'update', me, options);
        },

        deleteProfile: function (attrs, options) {
            const me = this;

            options = _.extend({
                validate: true,
                parse: true
            }, options);

            if (!me.set(attrs, options)) {
                return false;
            }

            options.url = [me.url(), 'deleteProfile'].join('/');
            options.success = function (resp) {
                me.trigger('sync', me, resp);
            };

            return (me.sync || Backbone.sync).call(me, 'update', me, options);
        },

        isInvited: function () {
            const me = this;
            return me.get('account_user_status_id') === RivalIQ.enums.user.status.invited.id;
        },

        isActive: function () {
            const me = this;
            return me.get('account_user_status_id') === RivalIQ.enums.user.status.active.id;
        },

        isOwner: function () {
            const me = this;
            return me.get('role_id') === RivalIQ.enums.roles.owner.id;
        },

        isReadOnly: function () {
            const me = this;
            return me.get('role_id') === RivalIQ.enums.roles.readOnly.id;
        },

        can: function (action, resource) {
            const me = this;
            return me.getRole().can(me, action, resource);
        },

        canEditField: function (resource, field) {
            const me = this;
            return me.getRole().field(me, resource, field);
        },

        getRole: function () {
            const me = this;
            return models.Role.findById(me.get('role_id'));
        }

    });
});
